import { getUserInfo } from "@/libs/utils";
import config from "@/config";
let watermark = null;

// 配置项
const DEFAULTS = {
  text: "", // 文本内容
  opacity: 0.15, // 透明度
  rotate: 20, // 倾斜角度
  size: 14, // 大小
  zIndex: 1,
};

export default (el, options = {}) => {
  // 需要保证当前调用元素的 position 属性为 absolute、relative 或 fixed
  const position = el.style.position;
  if (!["absolute", "relative", "fixed"].includes(position)) {
    el.style.position = "relative";
  }

  // 参数
  const _options = {
    ...DEFAULTS,
    ...options,
  };

  // 是否可以创建水印
  if (!options.text) {
    try {
      // 获取用户信息
      const user = getUserInfo();
      const phone = (user.mobile || "").split(",")[0];
      _options.text = `${user.nickname}-${phone.slice(-4)}`;
    } catch (error) {
      _options.text = config.title;
    }
  }

  // 画布的尺寸
  const rotate = (_options.rotate * Math.PI) / 180;
  const width = Math.min(_options.text.length * _options.size, 200);
  const height = width;

  // 创建水印图片 ： 创建画布 - 绘制内容 - 获取图片数据 - 显示为背景
  const canvas = document.createElement("canvas");
  canvas.width = width * 3;
  canvas.height = height * 3;
  const ctx = canvas.getContext("2d");
  ctx.rotate(-rotate);
  ctx.translate(-70, 70);
  ctx.font = `${_options.size * 2}px Arial`;
  ctx.fillStyle = "black"; // 字体颜色
  ctx.textAlign = "end";
  ctx.fillText(_options.text, canvas.width, canvas.height / 4);
  ctx.textAlign = "start";
  ctx.fillText(_options.text, 0, canvas.height - canvas.height / 3);

  // 追加元素

  const resetWatermark = () => {
    const targetStyles = {
      position: "fixed",
      bottom: "0",
      left: "0",
      right: "0",
      top: "0",
      zIndex: "1",
      opacity: _options.opacity,
      background: `url("${canvas.toDataURL("image/png")}") repeat`,
      backgroundSize: `${canvas.width / 2}px ${canvas.height / 2}px`,
      pointerEvents: "none",
    };
    if (watermark) {
      watermark.remove();
    }
    watermark = document.createElement("div");
    for (const [property, value] of Object.entries(targetStyles)) {
      watermark.style[property] = value;
    }
    el.append(watermark);
  };

  resetWatermark();

  // 禁止删除和修改
  if (typeof MutationObserver === "function") {
    // 创建 MutationObserver 实例
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        // 移除的情况
        for (let node of mutation.removedNodes) {
          if (node === watermark) {
            resetWatermark();
          }
        }
        // 修改属性的情况
        if (mutation.target === watermark) {
          resetWatermark();
        }
      }
    });
    // 启动监听
    observer.observe(el, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }
};
